const initailState = {
  singleOfferData: [],
  loadings:false
};

export function singleBrandReducer(state = initailState, { type, payload }) {
  switch (type) {
    case "GET_SINGLE_BRAND":
      return { ...state, singleOfferData: payload, loadings: false };
      case "GET_SINGLE_OFFERS":
        return { ...state, singleOfferData: payload, loadings: false };
    case "HIDE_SINGLE_BRAND_LOADDED":
      return { ...state, loadings: false };
    case "SHOW_SINGLE_BRAND_LOADING":
      return { ...state, loadings: true };
      case "COMPLETED_OFFER_SUCCESS":
      return { ...state, singleOfferData: payload, loadings: false };
    case "COMPLETED_OFFER_FAILED":
      return { ...state, loadings: false };
    case "COMPLETED_OFFER_LOADING":
      return { ...state, loadings: true };
    default:
      return state;
  }
}
